// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"2ac32657","300":"64134d76","417":"33ed2482","993":"3d17752a","4242":"a3ab9fa8","4492":"1734ad37","4530":"cdc2825e","5947":"3d17752a"}[chunkId] + ".chunk.css";
};